module.exports = __webpack_public_path__ + "img/cuotaSocial.bf62e38d.jpg";